export const FILL_REQUIRED_FIELDS = 'Please fill all the required fields';
